export default __webpack_public_path__ + "static/media/HardCheese.ecafaea3.png";